import React from 'react';
import { EntitiesCardTitle } from '../../components/entities-card/EntitiesCardTitle';
import { EntitiesTitleLink } from '../../components/entities-card/EntitiesTitleLink';

interface Props extends React.HTMLProps<HTMLAnchorElement> {}

type Sourceable = {
  source?: string;
};

export function LegislationCardTitleLink({
  children,
  ...props
}: Props & Sourceable) {
  return (
    <EntitiesTitleLink {...props}>
      <EntitiesCardTitle>{children}</EntitiesCardTitle>
    </EntitiesTitleLink>
  );
}
